import type { GetNotificationsResult } from "api-contracts/rpc/notifications";
import { appContext } from "../appContext";
import { queryOptions } from "../query-options";
import { rpc } from "../services/rpc";

export const notificationsQueryKey = "get-notifications";

export const notificationsQueryOptions = queryOptions<GetNotificationsResult | null>({
  queryKey: [notificationsQueryKey],
  queryFn: async (): Promise<GetNotificationsResult | null> => {
    await appContext.ready;
    if (!appContext.isAuthenticated) return null;
    return rpc<typeof notificationsQueryKey>(notificationsQueryKey, { limit: "50" });
  },
});
